module.exports = __webpack_public_path__ + "img/yangzhou.e34d2b72.png";